<template>
  <li>
    <div class="container">
      <div class="row">
        <div class="col">
          <strong>Descrição:</strong> {{ variacoes.descricao_sku }}
        </div>
        <div class="col">
          <strong>Quantidade:</strong> {{ variacoes.quantidade }}
        </div>
        <div class="col"><strong>Preço: </strong>R$ {{ precoindividual }}</div>
      </div>
    </div>
  </li>
</template>

<script>
export default {
  props: ["variacoes"],
  data() {
    return {};
  },
  computed: {
    precoindividual() {
      if (this.variacoes.preco !== null && this.variacoes.preco !== undefined) {
        return this.variacoes.preco.toLocaleString("pt-br", {
          minimumFractionDigits: 2,
        });
      } else {
        return "0,00"; 
      }
    },
  },
};
</script>

<style scoped>
li {
  padding: 0px;
}

.col {
  padding: 0px;
}
</style>
